const syncFailure = {
	name: 'Sync-Fehler',
	fields: {
		sync_module: 'Modul',
		sync_entity_id: 'ERP-Nr.',
		analysis: 'Problem',
		failed_at: 'Zeitpunkt',
	},
}

export default syncFailure
